// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetadataVariable } from './metadata-variable';
import {
    MetadataVariableFromJSON,
    MetadataVariableFromJSONTyped,
    MetadataVariableToJSON,
    MetadataVariableToJSONTyped,
} from './metadata-variable';

/**
 * 
 * @export
 * @interface TransferMetadataSchema
 */
export interface TransferMetadataSchema {
    /**
     * 
     * @type {string}
     * @memberof TransferMetadataSchema
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof TransferMetadataSchema
     */
    sheet?: string;
    /**
     * 
     * @type {Array<MetadataVariable>}
     * @memberof TransferMetadataSchema
     */
    variables?: Array<MetadataVariable>;
}

/**
 * Check if a given object implements the TransferMetadataSchema interface.
 */
export function instanceOfTransferMetadataSchema(value: object): value is TransferMetadataSchema {
    return true;
}

export function TransferMetadataSchemaFromJSON(json: any): TransferMetadataSchema {
    return TransferMetadataSchemaFromJSONTyped(json, false);
}

export function TransferMetadataSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferMetadataSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'] == null ? undefined : json['domain'],
        'sheet': json['sheet'] == null ? undefined : json['sheet'],
        'variables': json['variables'] == null ? undefined : ((json['variables'] as Array<any>).map(MetadataVariableFromJSON)),
    };
}

export function TransferMetadataSchemaToJSON(json: any): TransferMetadataSchema {
    return TransferMetadataSchemaToJSONTyped(json, false);
}

export function TransferMetadataSchemaToJSONTyped(value?: TransferMetadataSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': value['domain'],
        'sheet': value['sheet'],
        'variables': value['variables'] == null ? undefined : ((value['variables'] as Array<any>).map(MetadataVariableToJSON)),
    };
}
